<template>
  <div class>
    <Nav></Nav>
    <mdb-container class="mt-5">
      <mdb-row class="mb-4">
        <mdb-col class="text-left"></mdb-col>
      </mdb-row>
      <mdb-row class>
        <mdb-col sm="12" xl="3" class>
          <div class="avatar-big mb-4">
            <span>{{twoLettersCircleInterior}}</span>
          </div>
          <h2 class>{{memberEmailPrimaryKey}}</h2>
          <div class="mb-4">Joined {{userJoinedDateFromProfile}}</div>
        </mdb-col>
        <mdb-col sm="12" xl="9" class>
          <h4 class="mb-3 mt-5">Sales Skills Assessment Results</h4>
          <radar-chart
            id="radarchart1"
            :chart-data="datacollection"
            :padding="50"
            :options="options"
          ></radar-chart>
          <h4 class="mb-3 mt-5">Courses</h4>

          <div
            v-for="(item,index) in this.yourProgressInCoursesData"
            :key="'progressdiv'+index"
            class="progress-list-item"
          >
            <div class="progress-list-item-main">
              <h5 class="uppercase">{{item.courseFriendlyName}}</h5>
              <div class="progress-list-item-line">
                <mdb-badge
                  v-if="mthGetProgressBySlug(item.courseSlug)>97"
                  pill
                  color="bg-green"
                  class
                >COMPLETED</mdb-badge>
                <template v-else>
                  <span class="text-purple">{{Math.round(mthGetProgressBySlug(item.courseSlug))}}%</span>
                  <mdb-progress :height="5" :value="mthGetProgressBySlug(item.courseSlug)" />
                </template>
              </div>
            </div>
          </div>

          <!-- <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">How to sell to existing clients</h5>
                <div class="progress-list-item-line">
                  <mdb-badge pill color="bg-green" class>COMPLETED</mdb-badge>
                </div>
              </div>
            </router-link>
          </div>
          <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">Concise Communication</h5>
                <div class="progress-list-item-line">
                  <span class="text-purple">60%</span>
                  <mdb-progress :height="5" :value="60" />
                </div>
              </div>
            </router-link>
          </div>
          <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">How to win more clients</h5>
                <div class="progress-list-item-line">
                  <span class="text-purple">10%</span>
                  <mdb-progress :height="5" :value="10" />
                </div>
              </div>
            </router-link>
          </div>-->
          <h4 class="mb-3 mt-5">Videos</h4>

          <div
            v-for="(item,index) in this.yourProgressInVideosData"
            :key="'progressvdiv'+index"
            class="progress-list-item"
          >
            <div class="progress-list-item-main">
              <h5 class="uppercase">{{mthGetVimeonameByVimeoid(item.vimeoid)}}</h5>
              <div class="progress-list-item-line">
                <mdb-badge v-if="item.event.percent*100>97" pill color="bg-green" class>COMPLETED</mdb-badge>
                <template v-else>
                  <span class="text-purple">{{Math.round(item.event.percent*100)}}%</span>
                  <mdb-progress :height="5" :value="item.event.percent*100" />
                </template>
              </div>
            </div>
          </div>

          <!-- <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">How to sell to existing clients</h5>
                <div class="progress-list-item-line">
                  <mdb-badge pill color="bg-green" class>COMPLETED</mdb-badge>
                </div>
              </div>
            </router-link>
          </div>
          <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">Concise Communication</h5>
                <div class="progress-list-item-line">
                  <span class="text-purple">60%</span>
                  <mdb-progress :height="5" :value="60" />
                </div>
              </div>
            </router-link>
          </div>
          <div class="progress-list-item">
            <router-link to="/">
              <img
                src="https://appen.nazwa.pl/hardlight/projekty/ex2/win-2.jpg"
                class="img-fluid"
                alt="Responsive image"
              />
              <div class="progress-list-item-main">
                <h5 class="uppercase">How to win more clients</h5>
                <div class="progress-list-item-line">
                  <span class="text-purple">10%</span>
                  <mdb-progress :height="5" :value="10" />
                </div>
              </div>
            </router-link>
          </div>-->
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
//import LineChart from '../LineChart.js'
import Vue from "vue";
import firebase from "firebase/app";
import { store } from "../store";
import RadarChart from "../RadarChart.js";
import Nav from "../components/Nav";
import moment from "moment";
import Footer from "../components/Footer";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbProgress
} from "mdbvue";

Chart.defaults.global.defaultFontSize = 12;
Chart.defaults.global.animation.duration = 3000;

export default {
  components: {
    RadarChart,
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbProgress
  },
  data() {
    return {
      videosDictionary: [],
      memberKeyFromRouter: "",
      memberEmailPrimaryKey: "",
      twoLettersCircleInterior: "__",
      usernameBigLabel: "nobody",
      userJoinedDateFromProfile: "",
      memberLastAssessmentKey: "",
      yourProgressInCoursesData: [],
      yourProgressInCoursesPercent: [],

      yourProgressInVideosData: [],

      window: {
        width: 0,
        height: 0
      },
      simplereactivity: "",
      overallScore: 0.1,
      datacollection: {
        labels: [],
        datasets: [
          {
            label: "",
            borderWidth: "5",
            data: [],
            datacandidates: [] //setinterval animation start block
          }
        ],
        minicourses: []
      },
      options: {
        scale: {
          pointLabels: {
            fontSize: 14,
            fontFamily: "roboto",
            fontColor: "#7B8183",
            labelMaxWidth: 18,
            labelWrap: true
          }
        },
        responsive: false,
        maintainAspectRatio: false,
        responsive: true,
        responsiveAnimationDuration: 0,
        duration: 4000,
        beginAtZero: true,
        legend: {
          display: false,
          labels: {
            fontColor: "red",
            fontSize: 18
          }
        },

        elements: {
          line: {
            foreColor: "grey",
            backgroundColor: "yellow"
          },
          point: {
            radius: 3,
            pointStyle: "circle",
            borderColor: "#5542FB"
          }
        }
        // title: {
        //   display: true,
        //   text: "Custom Chart Title"
        // }
      }
    };
  },
  mounted() {
    //var timerID = setInterval(this.fillDataFromFirestore, 1000);
    this.fillDataFromFirestore();
    //setInterval(this.datacandidates2dataAnimate, 2000);
  },
  updated() {
    //console.log("UPDATED fired...");
  },
  created() {
    //region basic synchro
    this.memberKeyFromRouter = this.$router.currentRoute.params.memberkey;
    this.memberEmailPrimaryKey = this.mthConvertKeyFromRouterToEmail(
      this.memberKeyFromRouter
    );
    this.twoLettersCircleInterior = this.memberEmailPrimaryKey
      .substring(0, 2)
      .toUpperCase();
    this.usernameBigLabel = this.memberEmailPrimaryKey.split("@")[0];
    //endregion of basic synchro

    //radar
    this.mthfillProfileDataOnCreated();
    this.mthGetDataFromLastAssessment();

    //progress - courses
    this.mthfillProgressData();
    this.mthFillProgressPercents();

    //fill videos
    this.mthFillVideosDictionary();

    //progress in videos
    this.mthFillProgressInVideosData();

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    mthGetVimeonameByVimeoid(vimeoid) {
      let toret = this.videosDictionary.find(el => {
        if (el && el.data) return el.data.vimeoid === vimeoid;
        else return false;
      });

      if (toret) return toret.data.name;
      return "mthGetVimeonameByVimeoid: name not found";
    },
    mthFillVideosDictionary() {
      firebase
        .firestore()
        .collection("videos")
        .get()
        .then(result => {
          result.forEach(doc => {
            //console.log("returning 3 for " + slug);
            //this.toret = 3;
            this.videosDictionary.push({
              data: doc.data()
            });
          });
        })
        .then(() => {
          //console.log('videosDictionary: ')
          //console.log(this.videosDictionary)
        });
    },
    mthFillProgressInVideosData() {
      //console.log("mthfillProgressData: started");

      let refProgressVideos = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.memberEmailPrimaryKey)
        .get()
        .then(result => {
          result.forEach(doc => {
            //console.log("returning 3 for " + slug);
            //this.toret = 3;
            this.yourProgressInVideosData.push({
              courseslug: doc.data().courseslug,
              vimeoid: doc.data().vimeoid,
              vimeoidended: doc.data().vimeoidended,
              event: doc.data().event
            });
          });
        });
    },
    mthGetProgressBySlug(slug) {
      let toret = 0.00000001;
      let counter = 0;

      this.yourProgressInCoursesPercent.forEach(el => {
        if (el.slug !== undefined && el.slug == slug) {
          counter++;
          if (el.vimeoidended !== undefined) {
            //console.log("adding 100.001");
            toret += 100.001;
          } else if (
            el.vimeoid !== undefined &&
            el.event.percent !== undefined
          ) {
            //console.log("adding " + el.event.percent * 100);

            toret += el.event.percent;
          }
        }
      });

      if (counter == 0) return 0;

      toret = (toret * 100) / counter;
      if (toret > 98) toret = 100;

      return toret;
    },

    mthFillProgressPercents() {
      // console.log(
      //   "%mthFillProgressPercents will fill percents using email=" +
      //     this.emailFromStore,
      //   "color:green"
      // );

      const toret = 0;

      var snap = firebase
        .firestore()
        .collection("progressTracking")
        .where("userEmail", "==", this.memberEmailPrimaryKey)
        //.where("courseslug", "==", slug)
        .get()
        .then(result => {
          result.forEach(doc => {
            //console.log("returning 3 for " + slug);
            //this.toret = 3;
            this.yourProgressInCoursesPercent.push({
              slug: doc.data().courseslug,
              vimeoid: doc.data().vimeoid,
              vimeoidended: doc.data().vimeoidended,
              event: doc.data().event
            });
          });
        })
        .then(() => {
          //console.log("now yourProgressInCoursesPercent has items: ");
          //console.log(this.yourProgressInCoursesPercent);
        });

      return toret;
    },

    mthName2Slug(name) {
      return name.replace(" ", "-");
    },

    mthfillProgressData() {
      //console.log("mthfillProgressData: started");

      let refcourses = firebase.firestore().collection("courses");

      refcourses.onSnapshot(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.yourProgressInCoursesData.push({
            courseFriendlyName: doc.data().name,
            courseSlug: this.mthName2Slug(doc.data().name)
          });
        });
      });

      //console.log("%cmthfillProgressData: data is", "color:orange");
      //console.log(this.yourProgressInCoursesData);
    },

    mthGetDataFromLastAssessment() {
      //console.log("mthGetDataFromLastAssessment fired");

      let email = this.memberEmailPrimaryKey;
      let that = this;

      firebase
        .firestore()
        .collection("usersFilledAssessments")
        .where("user", "==", email)
        .orderBy("createdAt", "desc")
        .limit(1)
        .get()
        .then(result => {
          result.forEach(doc => {
            //console.log("assessment key is: " + doc.id);
            this.memberLastAssessmentKey = doc.id;

            //that.profileYourBusiness = doc.data().postAssessmentForm;
          });
        });
    },

    mthConvertKeyFromRouterToEmail(routerkey) {
      let ret = routerkey;
      ret = ret.replace("__", ".");
      ret = ret.replace("_", "@");
      return ret;
    },

    mthfillProfileDataOnCreated() {
      let userProfileDocRef = firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.memberEmailPrimaryKey);

      var userProfileDoc = userProfileDocRef
        .get()
        .then(doc => {
          if (!doc.exists) {
            /*             console.log(
              "userProfileDoc not exists for " + this.memberEmailPrimaryKey
            ); */
          } else {
            //console.log("userProfileDoc data:");
            this.userProfileObjectFromFirestore = doc.data();

            this.userJoinedDateFromProfile = "not found in profile";
            if (doc.data().joinedDate !== undefined)
              this.userJoinedDateFromProfile = moment(
                doc.data().joinedDate.seconds * 1000
              ).format("LLL");

            //console.log(this.userProfileObjectFromFirestore);
          }
        })
        .catch(err => {
          //console.log("userProfileDoc - Error getting document", err);
        });

      //result data
      this.usernameBigLabel = store.getters.getUser.email.split("@")[0];
      this.twoLettersCircleInterior = this.memberEmailPrimaryKey
        .substr(0, 2)
        .toUpperCase();
      //this.userJoinedDateFromProfile = moment(this.userProfileObjectFromFirestore.joinedDate).format("LTS");
    },

    datacandidates2dataAnimate0() {
      //console.log("datacandidates2dataAnimate0 called");
      //this.datacollection = {}
    },
    datacandidates2dataAnimate() {
      //var dataset = this.datacollection.datasets[0];

      for (
        var i = 0;
        i < this.datacollection.datasets[0].datacandidates.length;
        i++
      ) {
        //console.log("iterate....");

        this.simplereactivity =
          "simple reactivity works " + i.toString() + new Date().toString();

        if (
          this.datacollection.datasets[0].data[i] ==
          this.datacollection.datasets[0].datacandidates[i]
        ) {
          //nothing
          //console.log("doing nothing, data is ");
          //console.log(this.datacollection.datasets[0].data);
        } else {
          //rewrite only 1 and exit
          this.datacollection.datasets[0].data[
            i
          ] = this.datacollection.datasets[0].datacandidates[i];

          // Vue.set(
          //   this.datacollection.datasets[0].data,
          //   i,
          //   this.datacollection.datasets[0].datacandidates[i]
          // );

          /*           console.log(
            "doing sth and break, wrote to data: " +
              this.datacollection.datasets[0].datacandidates[i]
          ); */

          //this.$forceUpdate()

          break;
        }
      }
    },
    sortMinicourses() {
      //mcname, mcyourscore
      this.datacollection.minicourses.sort((a, b) =>
        a.mcyourscore > b.mcyourscore ? 1 : -1
      );
    },
    getColorByScore(score) {
      if (score <= 1) return "red";
      if (score <= 2) return "orange";
      if (score <= 3) return "bg-lightGreen";
      if (score <= 4) return "bg-green";
    },
    getPhotoUrlByMcName(name) {
      if (name == "Emotional intelligence")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/intelligence.jpg";
      if (name == "Questioning")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/questioning.jpg";
      if (name == "Resilience")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/resilience.jpg";
      if (name == "Influencing")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/influencing1.jpg";
      if (name == "Time management")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/time.jpg";
      if (name == "Listening")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/listening.jpg";
      if (name == "Storytelling")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/p-1.jpg";
      if (name == "Growth mindset")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/growth.jpg";
      if (name == "Rapport building")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/conversation.jpg";
      if (name == "Concise Communication ")
        return "https://appen.nazwa.pl/hardlight/projekty/ex2/presentation.jpg";
    },
    getTextByMcName(name) {
      if (name == "Emotional intelligence") return "";
      if (name == "Questioning") return "";
      if (name == "Resilience") return "";
      if (name == "Influencing") return "";
      if (name == "Time and priority management") return "";
      if (name == "Listening") return "";
      if (name == "Storytelling") return "";
      if (name == "Growth mindset") return "";
      if (name == "Rapport building") return "";
      if (name == "Concise Communication") return "";
    },
    getCourseUrlByMcName(name) {
      //console.log('name is '+name);

      return "/course/" + name.replace(" ", "");
    },
    fillDataFromFirestore() {
      // console.log(
      //   "calling fillDataFromFirestore, store.getters.getAssessmentIdParam = "
      // );
      // console.log(this.$store.getters.getAssessmentIdParam);

      //let biggest = citiesRef.where('population', '>', 2500000).orderBy('population').limit(2);

      var snap = firebase
        .firestore()
        .collection("usersFilledAssessments")
        .where("user", "==", this.memberEmailPrimaryKey)
        .orderBy("createdAt", "desc")
        .limit(1)
        .get()
        .then(result => {
          var data = {};
          result.forEach(doc => {
            //console.log(doc);
            data = doc.data();
          });

          //console.log("data is: ");
          //console.log(data);

          this.overallScore = Number(
            parseFloat(data.assessmentscore.toFixed(1))
          );

          this.datacollection = {
            labels: [],
            datasets: [{}],
            options: [
              {
                defaultFontSize: 40,
                legend: {
                  display: true
                }
              }
            ]
          };

          // console.log('slides length is: '+result.data().slides.length);
          // console.log('slides object is: ');
          // console.log(result.data().slides[0].skillname);

          this.datacollection.labels = [];
          this.datacollection.minicourses = [];
          this.datacollection.datasets[0].data = [];
          this.datacollection.datasets[0].datacandidates = [];

          for (var i = 0; i < data.slides.length; i++) {
            //console.log(result.data().slides[i].skillname);
            this.datacollection.labels.push(
              data.slides[i].skillname.split(" ")
            );
            //this.datacollection.labels.push(['push','array','to','array'])
            this.datacollection.minicourses.push({
              mcname: data.slides[i].skillname,
              mcyourscore: data.pointsarr[i].points
            });
            this.datacollection.datasets[0].datacandidates.push(
              //or data.push if no animation
              data.pointsarr[i].points
            );
            this.datacollection.datasets[0].data.push(data.pointsarr[i].points);
          }

          this.sortMinicourses(); //by rating ascending

          this.datacollection.datasets[0].borderColor = "#5542FB";
          this.datacollection.datasets[0].backgroundColor = false;
          this.datacollection.datasets[0].borderWidth = "2";
          this.datacollection.datasets[0].pointBorderWidth = "4";

          //console.log(this.datacollection);
        });
    },
    getRandomInt() {
      return Math.floor(Math.random() * 5);
    },
    getRandomIntFromZeroToArgMinus1(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (window.innerWidth < 768) {
        //console.log("komora");
        this.options.scale.pointLabels.fontSize = 12;
      } else {
        //console.log("desktop");
        this.options.scale.pointLabels.fontSize = 16;
      }
    }
  }
};
</script>

<style>
@import url("https://use.typekit.net/lel8wuy.css");
</style>
